export const getLatestAssignment = (assignments = []) => {
  const latestAssignment = assignments.sort(
    (a, b) => new Date(b.date_goes_live) - new Date(a.date_goes_live),
  )[0];

  const latestAssignmentIsMVE =
    latestAssignment?.version === "single_asset_mve";
  if (latestAssignmentIsMVE) return latestAssignment;

  return null;
};
